import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'components/Popup/popup';
import Form from 'components/react-validation/components/form';
import Textarea from 'components/react-validation/components/text-area';
import * as Vali from 'helper/validator-helper';
import Submit from 'components/react-validation/components/submit';

const popupStyle = {
  width: 500,
  top: -255,
  left: 60
};

class DeclinePopup extends React.Component {
  static propTypes = {
    onSaveDeclinePopup: PropTypes.func,
    onCancelDeclinePopup: PropTypes.func
  }

  constructor(props) {
    super(props);
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.props.onSaveDeclinePopup(this.form.getValues().reason);
  }

  render() {
    return (
      <Popup ref={(ref) => { this.resolvePopup = ref; }} isHasFaded={true} styles={popupStyle} isHasFaded={true}>
        <Form className='form-horizontal' ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
          <div style={{ paddingTop: 10, paddingBottom: 10 }}>
            <div className='form-group'>
              <div className='col-sm-12 col-xs-12'>
                <label
                  className='col-xs-12'>Reason:</label>
                <div className='col-xs-12'>
                  <Textarea
                    name='reason'
                    ref='reason'
                    className='form-control'
                    placeholder='Your reason'
                    max='1000'
                    maxLength='1000'
                    style={{ height: 100 }}
                    validations={[Vali.required, Vali.maxlength]} />
                </div>
              </div>
            </div>
            <ul className='wo-popup-bottom-btn' style={{ paddingLeft: 5, borderTop: 0, marginTop: -10 }}>
              <li>
                <button
                  className='btn btn-primary btn-siteone-default btn-wo-edit'
                  onClick={this.props.onCancelDeclinePopup}>
                  Cancel
                </button>
              </li>
              <li>
                <Submit
                  className='btn btn-primary btn-siteone btn-wo-decline'>
                  Save
                </Submit>
              </li>
            </ul>
          </div>
        </Form>
      </Popup>
    );
  }
}

export default DeclinePopup;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/DeclinePopup.js